"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHttpStream;
function isHttpStream(url) {
  return (/^http:\/\//.test(url)
  );
}
//# sourceMappingURL=isHttpStream.js.map